import User from 'typescript/models/User';

export const isAdmin = (user: User) => user?.attributes.admin;

export const isManager = (user: User) => (user?.attributes.admin ? false : true);
